
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.18 10L2 3.82 3.818 2 10 8.181 16.18 2 18 3.82 11.818 10l6.18 6.18L16.18 18 10 11.82 3.818 18 2 16.18 8.18 10","fill":"#7D7D7D","fill-rule":"evenodd"}})])
          )
        }
      }
    